export enum UserRole {
    SYSADMIN = 'SYSADMIN',
    MAINTAINER = 'MAINTAINER',
    ANALYST = 'ANALYST'
}